import { Flex, Progress, Typography } from "antd";
import { analyticsTheme } from "../../components/analytics/analyticsTheme";
import { formatPct } from "../../components/analytics/utils/";
import { depthColor } from "./utils";

export type PercentBarProps = {
  percent: number;
};

// Colour-coded percentage bar shared by the readDepth and videoCompletion columns.
export const PercentBar = ({ percent }: PercentBarProps) => {
  const color = depthColor(percent);
  return (
    <Flex align="center" gap={8}>
      <Progress
        percent={Math.min(100, Math.max(0, percent))}
        showInfo={false}
        strokeColor={color}
        trailColor={analyticsTheme.barTrack}
        size={{ height: 6 }}
        style={{ flex: 1, margin: 0 }}
      />
      <Typography.Text
        style={{
          minWidth: 36,
          textAlign: "right",
          fontSize: 13,
          fontWeight: 500,
          color,
        }}
      >
        {formatPct(percent)}
      </Typography.Text>
    </Flex>
  );
};
